module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/1B88NUl/tc-custom/9781634869256.jpg?1729379716361",
      "alt": "This image is the cover for the book Got the Blues, Rainbow Connection"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Got the Blues, Rainbow Connection\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Sequel to "), _c('i', [_vm._v("On a Roll")]), _c('br'), _c('br'), _vm._v("Rising sophomore Beau Watkins gave up everything to be with his boyfriend Vin. Beau is disowned by his father and tormented by his brother, is rapidly running out of money, and suffers from Post-Traumatic Stress Disorder. On top of that, his boyfriend seems to see Beau as little more than a live-in maid."), _c('br'), _c('br'), _vm._v("Troubled by word of his own missing father and fighting nightmares of his own, Vin Reyes turns to alcohol to drown his pain. What's worse, a handsome transfer student is a little too interested in Beau. Vin throws away everything that's made him happy with both hands, terrified of his own feelings of inadequacy."), _c('br'), _c('br'), _vm._v("When Vin and Beau's happily-ever-after turns into a train wreck of drinking problems, resentment, insecurity, jealousy, and violence, will they be able to pick up the shattered pieces of their lives? Can they win through doubt and guilt, jealousy and recklessness, to find their place together in the world?")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Lynn Townsend\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Described as a social tornado, Lynn Townsend is a geek, a dreamer and an inveterate punster. When not reading, writing, or editing, she can usually be found drinking coffee or killing video game villains. Lynn's interests include filk music, romance novels, octopuses, and movies with more FX than plot. For more information, please visit paidbytheweird.blogspot.com.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0